export default __webpack_public_path__ + "static/media/button-message.7202d5bb.svg";